import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMainComponent implements OnInit {
    public presentations: any[] = [];
    public templates: any[] = [];
    public loading: boolean = true;
    public searchText: string = '';
    public showCreateModal: boolean = false;
    public showTemplateModal: boolean = false;
    public uploading: boolean = false;
    public newTitle: string = '';
    public selectedTemplateId: string = '';

    private searchTimer: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        let res = await wiz.call("list", { text: this.searchText });
        if (res.code === 200) {
            this.presentations = res.data.rows || [];
        }

        let tRes = await wiz.call("templates");
        if (tRes.code === 200) {
            this.templates = tRes.data.rows || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public async onSearch() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(async () => {
            await this.load();
        }, 300);
    }

    public openCreate() {
        this.newTitle = '';
        this.selectedTemplateId = '';
        this.showCreateModal = true;
        this.service.render();
    }

    public async doCreate() {
        if (!this.newTitle.trim()) {
            await this.service.modal.error("제목을 입력해주세요.");
            return;
        }
        let res = await wiz.call("create", { title: this.newTitle, template_id: this.selectedTemplateId });
        if (res.code === 200) {
            this.showCreateModal = false;
            this.service.href(`/editor/${res.data.id}`);
        } else {
            await this.service.modal.error(res.data?.message || "생성에 실패했습니다.");
        }
    }

    public openEditor(item: any) {
        this.service.href(`/editor/${item.id}`);
    }

    public async deletePres(event: any, item: any) {
        event.stopPropagation();
        let confirmed = await this.service.modal.show({
            title: '삭제 확인',
            message: `"${item.title}" 프레젠테이션을 삭제하시겠습니까?`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        let res = await wiz.call("delete_pres", { id: item.id });
        if (res.code === 200) {
            await this.load();
        }
    }

    public getSlideCount(item: any): number {
        try {
            return JSON.parse(item.slides_data || '[]').length;
        } catch { return 0; }
    }

    // Template management
    public async openTemplates() {
        this.showTemplateModal = true;
        await this.service.render();
    }

    public async onFileSelect(event: any) {
        const file = event.target.files[0];
        if (!file) return;
        event.target.value = '';

        if (!file.name.endsWith('.pptx')) {
            await this.service.modal.error("PPTX 파일만 업로드 가능합니다.");
            return;
        }

        this.uploading = true;
        await this.service.render();

        const formData = new FormData();
        formData.append('file', file);
        formData.append('name', file.name.replace('.pptx', ''));

        try {
            let res = await this.service.file.upload(`/wiz/api/${wiz.meta.id}/upload_template`, formData);
            if (res.code === 200) {
                await this.load();
            } else {
                await this.service.modal.error(res.data?.message || "업로드에 실패했습니다.");
            }
        } catch (e: any) {
            await this.service.modal.error("업로드 중 오류가 발생했습니다.");
        }

        this.uploading = false;
        await this.service.render();
    }

    public async deleteTemplate(event: any, tmpl: any) {
        event.stopPropagation();
        let confirmed = await this.service.modal.show({
            title: '삭제 확인',
            message: `"${tmpl.name}" 템플릿을 삭제하시겠습니까?`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        let res = await wiz.call("delete_template", { id: tmpl.id });
        if (res.code === 200) {
            await this.load();
        }
    }

    public getLayoutCount(tmpl: any): number {
        try {
            return (JSON.parse(tmpl.metadata || '{}').layouts || []).length;
        } catch { return 0; }
    }
}

export default PageMainComponent;